import React, { FC } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useBackgroundColor } from "../../utils";
import Details from "../details/Details";
import Blade from "../blade/Blade";
import { Fee, Limit, LinkType } from "../../types";
import Html from "../html/Html";
import Stack from "../stack/Stack";
import { Link, graphql, useStaticQuery } from "gatsby";

export interface AccountFeesProps {
  heading: string;
  subHeading: string;
  accountName: string;
  feeSmallPrint?: string;
  fees: Fee[];
  limits: Limit[];
  allFeesLink: LinkType;
  hideArrow?: boolean;
}

const StyledDetails = styled(Details)`
  ${({ theme: { space, borderRadii } }) => css`
    ${useBackgroundColor("white")}
    padding: ${space.fluidSmallToLarge};
    border: solid 1px currentColor;
    border-radius: ${borderRadii.small};
  `};
`;

const StyledFees = styled(Html)`
  ${({ theme: { space, borderRadii } }) => css`
    ${useBackgroundColor("white")}
    padding: ${space.fluidSmallToLarge};
    border: solid 1px currentColor;
    border-radius: ${borderRadii.small};
  `};
`;

export const AccountFees: FC<AccountFeesProps> = ({
  heading,
  subHeading,
  accountName,
  fees,
  limits,
  feeSmallPrint,
  allFeesLink,
  hideArrow
}) => {
  

  return (
    <Blade
      buttonLabel="Show all fees"
      buttonVariant="link"
      heading={heading}
      subHeading={subHeading}
      backgroundColor="yellow"
      hideArrow={hideArrow}
    >
      <Stack gap="fluidSmallToMedium">
        {fees && fees.length > 0 && (
          <StyledDetails
            items={fees}
            callToAction={allFeesLink}
          />
        )}
        {limits && limits.length > 0 && (
          <StyledDetails
            items={limits}
            heading={`${accountName} account limits`}
          />
        )}
        {feeSmallPrint && <StyledFees>{feeSmallPrint}</StyledFees>}
      </Stack>
    </Blade>
  );
};

export default AccountFees;
